// use gsap splittext and scrolltrigger to animate words on scroll
import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(SplitText, ScrollTrigger);

type SplitInstance = {
  trigger: ScrollTrigger;
  split?: SplitText;
};

const instances = new WeakMap<HTMLElement, SplitInstance>();
const tweens = new WeakMap<HTMLElement, gsap.core.Tween>();

const unwrapLineParents = (element: HTMLElement) => {
  const parents = element.querySelectorAll<HTMLElement>('.lineParent');
  parents.forEach((parent) => {
    const child = parent.firstChild;
    if (child) {
      parent.replaceWith(child);
    } else {
      parent.remove();
    }
  });
};

const setupElement = (element: HTMLElement) => {

  // element may container other block elements,
  // we want to animate each block element separately
  const blockElements = element.querySelectorAll<HTMLElement>(':scope > p,blockquote,div,h1,h2,h3,h4,h5,h6');
  if (blockElements.length > 0) {
    blockElements.forEach((child) => {
      child.classList.add('text-animation--slide-up-words');
      setupElement(child);
    });
    element.classList.remove('text-animation--slide-up-words');
    return;
  }

  if (element.dataset.animateSlideUpWordsDone === 'true') {
    return;
  }
  if (element.dataset.animationState === 'animating') {
    return;
  }

  const existing = instances.get(element);
  if (existing) {
    existing.trigger.kill();
    if (existing.split) {
      existing.split.revert();
      unwrapLineParents(element);
    }
  }
  const runningTween = tweens.get(element);
  if (runningTween) {
    runningTween.kill();
    tweens.delete(element);
  }

  let trigger: ScrollTrigger;
  trigger = ScrollTrigger.create({
    trigger: element,
    start: 'top bottom-=100px',
    once: true,
    onEnter: (self) => {
      // const staggerDelay = getStaggerDelay('global');
      // set the 
      element.dataset.animationState = 'animating';
      const activeTrigger = self;
      element.innerHTML = element.innerHTML.replace(/-/g, '<span class="dash">-</span>');
      const split = new SplitText(element, { type: 'lines, words' });
      split.lines.forEach((line) => {
        line.classList.add('lineChild');
        const parent = document.createElement('span');
        parent.className = 'lineParent';
        line.parentNode?.insertBefore(parent, line);
        parent.appendChild(line);
      });
      split.words.forEach((word) => word.classList.add('word'));
      const words = element.querySelectorAll<HTMLElement>('.word');
      instances.set(element, { trigger: activeTrigger, split });
      const tween = gsap.from(words, {
        yPercent: 100,
        // delay: 0.15 + staggerDelay,
        duration: 0.9,
        ease: 'power4.out',
        stagger: 0.03,
        clearProps: 'transform',
        onComplete: () => {
          element.dataset.animationState = 'done';
          activeTrigger.kill();
          split.revert();
          unwrapLineParents(element);
          element.dataset.animateSlideUpWordsDone = 'true';
          instances.delete(element);
          tweens.delete(element);
        }
      });
      tweens.set(element, tween);
    }
  });

  instances.set(element, { trigger });
};

const init = (elements: HTMLElement[]) => {
  elements.forEach((element) => setupElement(element));

};

export default {
  selector: '.text-animation--slide-up-words',
  init
};
